// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"7fe8c6c0","821":"507f7587","977":"7eddf1e4"}[chunkId] + ".chunk.js";
};